<template>
    <div>
        <title-ribbon v-if="list===false" title="افزودن شماره خود"></title-ribbon>
        <setting></setting>
            <div :class="!list ? 'mt-20 pt-10 col-md-10 mx-auto' : 'mt-5'">
                <div style="border: none">
                    <span class="mr-3">تعداد شماره های قابل اضافه  :  <span>{{
                            reachable
                        }}</span>
                                    </span>
                    <v-card-text>
                        <v-alert
                                dismissible
                                elevation="12"
                                type="success"
                                v-model="alertConfirm"
                                v-if="alertConfirm===true"
                                transition="slide-y-transition"
                                class="my-5"
                        >
                            کد تایید برای شما تا دقایقی دیگر ارسال میگردد.
                        </v-alert>
                        <v-row v-if="expired===false && (reachable > 0)">
                            <v-col cols="12" sm="6">
                                <v-text-field
                                        v-model="number"
                                        label="شماره تماس"
                                        required
                                        @keypress="allowOnlyNumbers($event,name,type)"
                                        @keypress.enter="getConfirmCode"
                                        pattern="[0-9]*"
                                        inputmode="numeric"
                                        :rules="numberRules"
                                        maxLength="10"
                                        class="mt-5"
                                        name="phone"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        hint="شماره تماس وارد شده فقط باید شامل اعداد باشد."
                                        counter="10"
                                        :loading="loading===true"
                                        :disabled="checkCode===true"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" v-show="checkCode===true">
                                <v-text-field
                                        v-model="confirmCode"
                                        label="کد تایید"
                                        required
                                        ref="confirmCode"
                                        name="verifyCode"
                                        @keypress.enter="submitCode"
                                        @keypress="allowOnlyNumbers($event,name,type)"
                                        pattern="[0-9]*"
                                        maxLength="6"
                                        inputmode="numeric"
                                        class="mt-5"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        hint="کد تایید ارسال شده به شماره خود را وارد کنید."
                                        :counter="max"
                                        maxlength="6"

                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="expired===false && reachable > 0">
                            <v-col cols="12" sm="4" v-show="checkCode===false">
                                <v-btn
                                        v-status="'divar_phone'"
                                        @click="getConfirmCode"
                                        :disabled="!number"
                                        class="btn-get-code"
                                >
                                    <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                                    دریافت کد تایید
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="4" v-show="checkCode===true">
                                <v-btn
                                        class="submit-btn"
                                        @click="submitCode"
                                        :disabled="!confirmCode"
                                >
                                    <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                                    ثبت کد تایید
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-left mr-auto">
                                <v-btn
                                        color="primary"
                                        text
                                        @click="checkCode = false"
                                >
                                    <span class="material-icons">keyboard_return</span>
                                    بازگشت
                                </v-btn>
                            </v-col>
                        </v-row>
                        <div v-if="expired===true">
                            <v-alert
                                    color="red"
                                    elevation="4"
                                    outlined
                                    type="error"
                                    class="my-5"
                            >
                                شما قادر به اضافه کردن شماره جدیدی نیستید.
                                برای اضافه کردن شماره جدید بسته <b>افزایشی خرید</b> کنید.
                            </v-alert>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="reachable <= 0">
                        <div class="row mx-auto">
                            <p class="font-weight-bold mx-1 text-dark"> قیمت هر لاین : <span class="font-weight-bold">{{
                                    perLinePrice
                                }}</span>
                            </p>
                            <p class="font-weight-bold text-dark mr-auto">مدت هر لاین : <span
                                    class="font-weight-bold">{{ expireTime }}</span></p>
                        </div>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                        v-model="linesCount"
                                        label="تعداد لاین"
                                        name="number"
                                        @keypress="allowOnlyNumbers($event,name,type)"
                                        required
                                        pattern="[0-9]*"
                                        class=""
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        hint="تعداد لاین وارد شده تا سه رقم می تواند باشد."
                                        counter="3"
                                        maxlength="3"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-col cols="12">
                            <v-btn
                                    class="btn-buy"
                                    :disabled="linesCount <= 0"
                                    @click="buySlot(linesCount)"
                            >
                                <span class="fa fa-shopping-bag ml-2" style="font-size: 1.2rem"></span>
                                خرید لاین
                            </v-btn>
                        </v-col>

                    </v-card-text>
                </div>
            </div>
    </div>
</template>
<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Setting from "@/view/pages/setting";
import Swal from "sweetalert2";
import {Bus} from "@/main";
import Sim from "@/view/sim";

export default {
    name: "addNewNumbers",
    components: {Sim, Setting, TitleRibbon},
    props:{
        list:{
            default:false
        }
    },
    data() {
        return {
            tab: null,
            checkCode: false,
            linesCount: '',
            price: 0,
            expire: 0,
            expired: false,
            reachable: '',
            max: 6,
            addOwnNum: false,
            perLinePrice: '',
            number: '',
            expireTime: '',
            loading: false,
            confirmCode: '',
            numberRules: [
                v => !!v || 'شماره را وارد کنید',
                v => (v.length === 11) || 'شماره را به درستی وارد کنید',
            ],
            alertConfirm: false,
        }
    },
    methods: {
        getConfirmCode() {
            const vm = this;
            vm.loading = true;
            $.ajax({
                url: `${url}/phone/authenticate`,
                type: 'POST',
                data: {phone: parseInt(vm.number)},
                fn: this.getConfirmCode,
                headers: {
                    'ACCEPT': 'application/json',
                    Authorization: Token
                },
                msg: false,
                statusCode: {
                    200: function (res) {
                        vm.checkCode = true;
                        vm.$nextTick(function () {
                            vm.$refs.confirmCode.focus();
                        })
                        vm.loading = false;
                    },
                    422: function (res) {
                        //FIXME: Haji man tarsidam ino dat bezaram
                        if (res.responseJSON.errors.phone[0] === 'validation.numeric') {
                            vm.checkCode = false;
                            vm.confirmCode = '';
                            Swal.fire({
                                title: 'خطا',
                                icon: 'error',
                                text: 'شماره وارد شده باید فقط شامل اعداد باشد!',
                                type: 'error',
                                confirmButtonText: 'باشه'
                            })
                        } else if (res.responseJSON.errors.phone[0] === 'validation.required') {
                            vm.checkCode = false;
                            vm.confirmCode = '';
                            Swal.fire({
                                title: 'خطا',
                                icon: 'error',
                                text: 'شماره را وارد کنید!',
                                type: 'error',
                                confirmButtonText: 'باشه'
                            })
                        } else if (res.responseJSON.errors.phone[1] === 'validation.min.numeric') {
                            vm.checkCode = false;
                            vm.confirmCode = '';
                            Swal.fire({
                                title: 'خطا',
                                icon: 'error',
                                text: 'شماره را به درستی وارد کنید!',
                                type: 'error',
                                confirmButtonText: 'باشه'
                            })
                        } else if (res.responseJSON.errors.phone[1] === 'validation.digits') {
                            vm.checkCode = false;
                            vm.confirmCode = '';
                            Swal.fire({
                                title: 'خطا',
                                icon: 'error',
                                text: 'شماره را به درستی وارد کنید!',
                                type: 'error',
                                confirmButtonText: 'باشه'
                            })
                        }
                    }
                }
            });
        },
        submitCode() {
            const vm = this
            $.ajax({
                url: `${url}/phone/verify`,
                type: 'POST',
                fn: this.submitCode,
                data: {
                    phone: parseInt(vm.number),
                    code: vm.confirmCode,
                },
                headers: {
                    'ACCEPT': 'application/json',
                    Authorization: Token
                },
                msg: true,
                statusCode: {
                    201: ((res) => {
                        vm.loading = false;
                        vm.checkCode = false;
                        vm.confirmCode = '';
                        this.number = '';
                        this.getSlut()
                    }),
                    422: (function (res) {
                        vm.loading = false;
                        vm.checkCode = false;
                        vm.confirmCode = '';
                    })
                }
            })
        },
        getSlut() {
            $.ajax({
                url: `${url}/user/profile`,
                type: "GET",
                fn: this.getSlut,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token
                },
                success: (res) => {
                    this.reachable = res.data.slot;
                }
            })
        },
        buySlot(slotCount) {
            $.ajax({
                url: `${url}/shop/number/slot/${slotCount}`,
                type: 'POST',
                fn: this.buySlot,
                params: [slotCount],
                headers: {
                    'ACCEPT': 'application/json',
                    Authorization: Token
                },
                msg: true,
                statusCode: {
                    200: (res) => {
                        this.reachable = this.linesCount;
                        this.linesCount = 0;
                        this.number = '';
                        this.getSlut()
                    },
                }
            });
        },
        allowOnlyNumbers(value, name, type) {
            if (typeof value.key != "") {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
    },
    mounted() {
        this.getSlut();
        Bus.$on('sendSetting', (value) => {
            this.expireTime = value.expire;
            this.perLinePrice = value.price
        })
    }

}
</script>

<style scoped>
.buyBtn {
    transition: 0.5s;
    background-size: 200% auto;
    color: #1c0152;
    border-radius: 5px;
    display: block;
    font-size: 12pt;
    text-align: center;
}

.buyBtn:hover {
    background-image: linear-gradient(to right, #5C258D 0%, #4389A2 51%, #5C258D 100%);
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
    border: none;
}

.fa-plus:hover {
    color: white !important;
}
.rp-spinner:hover .rp_svg{
    animation:  rp 4s linear infinite;
    transform: rotate3d(0, 1, 0, 369deg);
}

@keyframes rp{
    from{
        transform: rotate3d(0,0,0,0);
    }

    to{
        transform: rotate3d(0, 1, 0, 360deg)
    }
}
</style>